import { TableRowActions } from './table-row-actions';

export { TableRowActions };
